import ErrorComponent from "@/components/universal/error";

export default function RootErrorBoundary({ error }: { error: unknown }) {
  console.error(error);

  if (error instanceof Error) {
    return (
      <ErrorComponent
        title="An unexpected error occurred"
        text={error.message}
      />
    );
  }

  return (
    <ErrorComponent
      title="Error"
      text="Whoops! Something went wrong. Please contact support if this issue persists."
    />
  );
}
